const META_KEYS = ["page", "page_size", "serializer"];

export default function buildApiParams({ params, page = 1 }) {
  const topLevel = {};
  const q = {};

  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;

    if (META_KEYS.includes(key)) {
      topLevel[key] = value;
    } else {
      q[key] = value;
    }
  }

  topLevel.page = page;

  const hasQueryParams = Object.keys(q).length > 0;

  if (hasQueryParams) {
    return { ...topLevel, q };
  } else {
    return topLevel;
  }
}
